module.exports = __webpack_public_path__ + "static/media/af15.4f89cc34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/af15.jpg
// module id = 167
// module chunks = 0